'use strict';

import config from 'config';
import React, { Component } from 'react';
import CardContainer from 'components/CardContainer';
import ActionButton from 'components/ActionButton';

const { LABELS } = config;

class ChatOverlayConfirmClose extends Component {
	constructor(props) {
		super(props);

		this.showFeedbackRequest = this.showFeedbackRequest.bind(this);
	}

	showFeedbackRequest() {
		this.props.onFeedbackRequest();
	}

	render() {
		return (
			<div className="confirm-close">
				<CardContainer title={LABELS.close_overlay_title || 'Do you really want to leave the current chat?'} addClass="" contentAddClass="">
					<p>{LABELS.close_overlay_subtitle || 'You will be logged out and the conversation will be deleted.'}</p>
					<ActionButton addClass="btn btn-flat-red" label={LABELS.close_overlay_yes_button || 'Yes, close'} onClick={this.showFeedbackRequest}/>
					<ActionButton addClass="btn btn-flat-grey" label={LABELS.close_overlay_no_button || 'No'} onClick={this.props.onClose}/>
				</CardContainer>
			</div>
		);
	}
}

ChatOverlayConfirmClose.displayName = 'ChatOverlayConfirmClose';
ChatOverlayConfirmClose.propTypes = {
	onClose: React.PropTypes.func,
	onFeedbackRequest: React.PropTypes.func
};
export default ChatOverlayConfirmClose;


// WEBPACK FOOTER //
// ./src/components/ChatOverlayConfirmClose.js